// extracted by mini-css-extract-plugin
module.exports = {"division":"division_division__1mriK","division__line":"division_division__line__3i9Hu","division-refactor__action":"division_division-refactor__action__1Zrrw"};